if (!customElements.get('countdown-timer')) {
  customElements.define(
    'countdown-timer',
    class CountdownTimer extends HTMLElement {
      connectedCallback() {
        this.date = this.dataset.countdownDate;
        this.time = this.dataset.countdownTime || '22:00';
        this.clockContainer = this.querySelector('.flipclock');

        if (!this.date || !this.clockContainer) return;
        if (this.clockContainer.dataset.initialized) return;

        this.clockContainer.dataset.initialized = 'true';
        this.initClock();
      }

      initClock() {
        const [hours, minutes] = this.time.split(':');
        const target = new Date(this.date);
        target.setHours(parseInt(hours), parseInt(minutes), 0, 0);
        const now = new Date();

        if (target <= now) {
          this.onExpired();
          return;
        }

        this.clock = FlipClock.flipClock({
          parent: this.clockContainer,
          face: FlipClock.elapsedTime({
            to: target,
            format: '[DD]:[hh]:[mm]:[ss]',
          }),
          theme: FlipClock.theme({
            dividers: ':',
            labels: [['Jours'], ['Heures'], ['Minutes'], ['Secondes']],
            css: FlipClock.css({
              fontSize: '3rem',
            }),
          }),
          onStop: () => this.onExpired(),
        });
      }

      onExpired() {
        this.style.display = 'none';
      }
    }
  );
}
